/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSmartToyIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-smart-toy"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.25 16Q1.7 16 0.63 14.93Q-0.45 13.85 -0.45 12.3Q-0.45 10.78 0.64 9.71Q1.73 8.65 3.25 8.65L3.25 7.22Q3.25 6.13 4.03 5.35Q4.8 4.58 5.9 4.58L8.35 4.58Q8.35 3.05 9.41 1.99Q10.47 0.93 12 0.93Q13.53 0.93 14.59 1.99Q15.65 3.05 15.65 4.58L18.1 4.58Q19.2 4.58 19.98 5.35Q20.75 6.13 20.75 7.22L20.75 8.65Q22.27 8.65 23.36 9.71Q24.45 10.78 24.45 12.3Q24.45 13.85 23.38 14.93Q22.3 16 20.75 16L20.75 19.43Q20.75 20.52 19.98 21.3Q19.2 22.07 18.1 22.07L5.9 22.07Q4.8 22.07 4.03 21.3Q3.25 20.52 3.25 19.43ZM8.95 13.63Q8.95 13.63 9.32 13.63Q9.7 13.63 10.24 13.09Q10.78 12.55 10.78 11.8Q10.78 11.05 10.24 10.51Q9.7 9.97 8.95 9.97Q8.2 9.97 7.66 10.51Q7.13 11.05 7.13 11.8Q7.13 12.55 7.66 13.09Q8.2 13.63 8.95 13.63ZM15.05 13.63Q15.05 13.63 15.43 13.63Q15.8 13.63 16.34 13.09Q16.88 12.55 16.88 11.8Q16.88 11.05 16.34 10.51Q15.8 9.97 15.05 9.97Q14.3 9.97 13.76 10.51Q13.22 11.05 13.22 11.8Q13.22 12.55 13.76 13.09Q14.3 13.63 15.05 13.63ZM8.93 17.7L15.07 17.7Q15.63 17.7 16.01 17.31Q16.4 16.93 16.4 16.38Q16.4 15.82 16.01 15.44Q15.63 15.05 15.07 15.05L8.93 15.05Q8.38 15.05 7.99 15.44Q7.6 15.82 7.6 16.38Q7.6 16.93 7.99 17.31Q8.38 17.7 8.93 17.7Z" fill={color} />
    </svg>
  );
}
